import PostByIdBasicModel from "./PostByIdBasicModel";
import ProfileModel from "../../Profile/Models/ProfileModel";

export default class PostByIdFullModel extends PostByIdBasicModel {
  public userModel: ProfileModel = null;
}
